import React ,{useState} from 'react'
import {Box,InputBase,Divider,Typography,IconButton} from "@mui/material"
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined"

const Subscribe = () => {
  const [email,setEmail] = useState("")
  return (
    <Box
    width = "80%"
    margin = "80px auto"
    textAlign="center"
    >
      <IconButton>
        <MarkEmailReadOutlinedIcon fontSize = "large"/>
      </IconButton>
      <Typography variant='h3'>
        Subscribe To Our Newsletter
      </Typography>
      
      <Typography>
        and receive $20 coupon for your first order when you checkout
      </Typography>

      <Box
      p = "2px 4px"
      m = "15px auto"
      display = "flex"
      alignItems="center"
      width = "75%"
      backgroundColor = "#F2F2F2"
      >
          <InputBase 
            sx={{
              ml:1,
              flex : 1
            }}
            placeholder='Enter Your Email'
            onChange = {(e) => setEmail(e.target.value)}
            value = {email}
          />
          <Divider 
            sx={{height:28,margin:0.5,orientation:"vertical"}}
          />
          <Typography sx={{padding:"10px",":hover":{cursor:"pointer"}}}>Subscribe</Typography>
      </Box>
    </Box>
  )
}

export default Subscribe